"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplittingButton = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var uuid_1 = require("uuid");
var SplittingButton = function (props) {
    var uuid = (0, react_1.useMemo)(uuid_1.v4, []);
    if (props.actions.length === 1) {
        return react_1.default.createElement(storm_ui_1.Button, { onClick: props.actions[0].effect }, props.actions[0].value);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(storm_ui_1.SplitButton, { mainButtonLabel: props.actions[0].value, mainButtonOnClick: props.actions[0].effect }, props.actions.slice(1).map(function (action, index) { return (react_1.default.createElement(storm_ui_1.SplitButtonItem, { key: 'splitting_button_action_' + uuid + '_' + index, value: action.value, onClick: action.effect }, action.value)); }))));
};
exports.SplittingButton = SplittingButton;
